var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 100 100",
    height: 512,
    viewBox: "0 0 100 100",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_6.HTML"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_103_",
    d: "m19.648 80.009 30.352 9.991 30.352-9.991 4.978-70.009h-70.66zm53.087-58.29-.668 9.375h-34.726l.847 12.031h33.044l-2.012 28.219-19.22 6.422-19.219-6.422-.657-9.469h9.375l.19 2.577 10.311 3.422 10.313-3.422.842-11.952h-31.734l-2.156-30.781z",
    fill: "#e44d26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html-5.b40c0d472bff395085f45a9f023255ec.svg";
export { ForwardRef as ReactComponent };